import { createAuthApi } from '@modeling/account';
import { resolveCreditServiceBaseUrl } from './env';

export const creditApi = createAuthApi(resolveCreditServiceBaseUrl());
